import React from 'react';

// lazy pages
export const DashboardHome = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.DashboardHome }))
);
export const Profile = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.Profile }))
);
export const Wizard = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.Wizard }))
);
export const Home = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.Home }))
);
export const PublicDashboardHome = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicDashboardHome }))
);
export const PublicSkills = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicSkills }))
);
export const PublicPlans = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicPlans }))
);
export const PublicClients = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicClients }))
);
export const PublicClientOrganizationDetails = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicClientOrganizationDetails }))
);
export const PublicClientProjectDetails = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicClientProjectDetails }))
);
export const PublicCareers = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicCareers }))
);
export const PublicCareerDetails = React.lazy(() =>
  import('@/pages').then((m) => ({ default: m.PublicCareerDetails }))
);
export const CareerOverview = React.lazy(() =>
  import('@/pages/dashboard/career-overview').then((m) => ({ default: m.CareerOverview }))
);